import { render, staticRenderFns } from "./plainTextEditor.vue?vue&type=template&id=b685288a&scoped=true"
import script from "./plainTextEditor.vue?vue&type=script&lang=js"
export * from "./plainTextEditor.vue?vue&type=script&lang=js"
import style0 from "./plainTextEditor.vue?vue&type=style&index=0&id=b685288a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b685288a",
  null
  
)

export default component.exports